import { Grid, Typography, Link } from "@mui/material";

import { useResponsive } from "../../../Modulo_Responsive/Hooks/useResponsive";

const Tarjeta_Blog_Blog = ({ titulo, descripcion, imagen, link }) => {
    const { sCell } = useResponsive();

    return (
        <Grid
            container
            direction="column"
            size={{ xs: 12, sm: 12, md: 12 }}
            component="a"                           // ← <a> nativo del navegador
            href={link}                             // ← href real, no "to"
            aria-label={`Leer artículo: ${titulo}`}
            sx={{
                cursor: "pointer",
                textDecoration: "none",
                transition: "transform 0.3s ease",
                "&:hover": {
                    transform: "translateY(-8px)",
                },
            }}
        >
            {imagen && (
                <Grid container justifyContent="flex-start" alignItems="flex-start" size={{ xs: 12, sm: 12, md: 12 }}>
                    <img
                        src={imagen}
                        alt={`Imagen ilustrativa sobre ${titulo}`}
                        style={{ width: "100%", height: "220px", objectFit: "cover" }}
                    />
                </Grid>
            )}

            <Grid
                container
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-easing="ease-out"
                size={{ xs: 12, sm: 12, md: 12 }}
            >
                <Grid
                    container
                    data-aos="fade-up"
                    data-aos-duration="1000"
                    data-aos-easing="ease-out"
                    sx={{ pt: 1, minHeight: sCell ? 0 : 90 }}
                    size={{ xs: 12, sm: 12, md: 12 }}
                >
                    <Typography
                        component="h3"
                        variant="h3"
                        sx={{ fontSize: 20, fontWeight: 500, lineHeight: 1.4, color: "#000" }}
                    >
                        {titulo}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Tarjeta_Blog_Blog;